import { useQueryClient } from 'react-query';

import { QUOTE_DEFAULT_TYPES } from '@/common/constants';

const useSelectItem = (queryKey) => {
  const queryClient = useQueryClient();

  const mutate = ({ itemId, isSelected }) => {
    const previousData = queryClient.getQueryData(queryKey);

    return queryClient.setQueryData(queryKey, {
      ...previousData,
      quote_lines: previousData.quote_lines?.map((item) => {
        if (item.id === itemId && item.type === QUOTE_DEFAULT_TYPES.PRODUCT) {
          return {
            ...item,
            is_selected: isSelected,
            options: item.options.map((option) => ({
              ...option,
              is_selected: isSelected ? option.is_selected : false,
            })),
            variants: item.variants.map((variant) => ({
              ...variant,
              is_selected: false,
            })),
          };
        }
        return item;
      }),
    });
  };

  return {
    mutate,
  };

  // return useMutation({
  //   mutationKey: queryKey,
  //   mutationFn: (line) => new Promise((resolve) => {
  //     const previousData = queryClient.getQueryData(queryKey);
  //     resolve({
  //       ...previousData,
  //       quote_lines: previousData.quote_lines?.map((item) => {
  //         if (
  //           item.id === line.itemId &&
  //           item.type === QUOTE_DEFAULT_TYPES.PRODUCT
  //         ) {
  //           return {
  //             ...item,
  //             is_selected: line.isSelected,
  //             options: item.options.map((option) => ({
  //               ...option,
  //               is_selected: line.is_selected ? option.is_selected : false,
  //             })),
  //             variants: item.variants.map((variant) => ({
  //               ...variant,
  //               is_selected: false,
  //             })),
  //           };
  //         }
  //         return item;
  //       }),
  //     });
  //   }),
  //   onSuccess: (data) => {
  //     queryClient.setQueryData(queryKey, data);
  //   },
  // });
};

export default useSelectItem;
